/** Destino pós-auth quando o usuário veio da landing pelo fluxo de plano. */
export const AUTH_REDIRECT_CLUBES = '/clubes' as const;

export type AuthRedirectIntent = {
	afterAuthRedirect: typeof AUTH_REDIRECT_CLUBES;
};

export type RegisterInitData = {
	email?: string;
	password?: string;
	repeat_password?: string;
	id?: string;
};

export type RegisterFlowLocationState = Partial<AuthRedirectIntent> & {
	registerInit?: RegisterInitData;
};

export function isAuthRedirectIntent(
	state: unknown,
): state is AuthRedirectIntent {
	return (
		typeof state === 'object' &&
		state !== null &&
		(state as AuthRedirectIntent).afterAuthRedirect === AUTH_REDIRECT_CLUBES
	);
}

export function getRegisterInitFromLocation(
	state: unknown,
): RegisterInitData | null {
	if (typeof state !== 'object' || state === null) return null;

	const registerInit = (state as RegisterFlowLocationState).registerInit;
	if (!registerInit) return null;

	if (registerInit.id) return registerInit;
	if (registerInit.email && registerInit.password) return registerInit;

	return null;
}

export function createClubesAuthRedirectState(): {
	state: AuthRedirectIntent;
} {
	return { state: { afterAuthRedirect: AUTH_REDIRECT_CLUBES } };
}

export function buildRegisterComplementNavigationState(
	currentState: unknown,
	registerInit: RegisterInitData,
): { state: RegisterFlowLocationState } {
	return {
		state: {
			...(isAuthRedirectIntent(currentState) ? currentState : {}),
			registerInit,
		},
	};
}

export function forwardAuthRedirectNavigateOptions(
	state: unknown,
): { state: AuthRedirectIntent } | Record<string, never> {
	if (!isAuthRedirectIntent(state)) {
		return {};
	}

	return { state: { afterAuthRedirect: state.afterAuthRedirect } };
}

export function forwardRegisterFlowNavigateOptions(
	state: unknown,
): { state: RegisterFlowLocationState } | Record<string, never> {
	if (typeof state !== 'object' || state === null) {
		return {};
	}

	const next: RegisterFlowLocationState = {};

	if (isAuthRedirectIntent(state)) {
		next.afterAuthRedirect = state.afterAuthRedirect;
	}

	const registerInit = getRegisterInitFromLocation(state);
	if (registerInit) {
		next.registerInit = registerInit;
	}

	if (Object.keys(next).length === 0) {
		return {};
	}

	return { state: next };
}

export function resolvePostFormDestination(
	state: unknown,
): '/clubes' | '/home' {
	return isAuthRedirectIntent(state) ? AUTH_REDIRECT_CLUBES : '/home';
}

/** Após auth com intenção da landing: formulário se houver pendência, senão clubes. */
export function resolvePostAuthClubFlowPath(
	state: unknown,
	hasPendingForm: boolean,
): typeof AUTH_REDIRECT_CLUBES | '/formulario' | null {
	if (!isAuthRedirectIntent(state)) return null;
	return hasPendingForm ? '/formulario' : AUTH_REDIRECT_CLUBES;
}
